const private_constants = {
    'APP_NAMES': ['ia'],

    'IA_SEATING_DEFAULT_COLOR': '#4abdac',
    'IA_WORKPLAN_WEEK_PARITY': {
        //key = week_id from database
        1: {
            name: 'wszystkie',
            abbr: '',
            mod2: null,
        },
        2: {
            name: 'parzyste',
            abbr: 'P',
            mod2: 0,
        },
        3: {
            name: 'nieparzyste',
            abbr: 'NP',
            mod2: 1,
        }
    },
    'IA_PLACE_COLOR': {
        //key = pk of Place from database
        1: 'rgb(238, 238, 238)', //light grey
        2: 'rgb(243, 243, 243)', //light grey
        3: 'rgb(251, 255, 222)', //yellow
        4: 'rgba(231, 223, 255, 0.31)', //purple
        5: 'rgba(218, 255, 255, 0.52)', //blue
        7: 'rgba(0, 195, 165, 0.4)', // ZL green
    },
    'IA_REPORT_BUTTON_DEFAULT_PLACE': 'Puławska', // Puławska/dom
    'DATE_FORMAT_FOR_BACKEND': 'YYYY-MM-DD',
    'MIDNIGHT_SUFFIX_FOR_BACKEND': 'T00:00:00',
    'NOTIFY_LONG_TIME': 5000,
    'COLORS': ['BlueViolet', '#bd2634', '#61d195', '#2b91c5', 'Crimson', 'CadetBlue', 'DarkGreen', 'DarkOrange',
               'DarkMagenta', 'DarkSlateGrey', 'DeepSkyBlue', 'GoldenRod', 'GreenYellow', 'HotPink', 'Indigo', 'LightSeaGreen', ],

    'WORK_SUMMARY_MIN_YEAR': 2013,
    'WORK_SUMMARY_MIN_MONTH_WORK': 20,
    'MONTHLY_OVERVIEW': 'Przegląd roczny',

    'DEFAULT_REPORT_FROM_TIME_MINUTES': 540,
    'DEFAULT_REPORT_TO_TIME_MINUTES': 1020,

    'DEFAULT_REPORT_FROM_TIME': '09:00',
    'DEFAULT_REPORT_TO_TIME': '17:00',

    'REPORT_ELAPSED_TIME_REFRESH_INTERVAL': 1000, //in milliseconds
};

export default {
    get(name) {
        return JSON.parse(JSON.stringify(private_constants[name]));
    }
}



// WEBPACK FOOTER //
// ./app/constants.js